import { get } from 'lodash';
import { EDITABLE_NOTE_CATEGORIES } from '../constants';

export const getInteractionDateParts = (interactionDate = {}) => ({
  day: get(interactionDate, 'day', ''),
  month: get(interactionDate, 'month', ''),
  year: get(interactionDate, 'year', ''),
  time: get(interactionDate, 'time', ''),
});

export const getProcessedNoteMetadata = (note = {}) => ({
  type: get(note, '_processedNoteType', null),
  added: get(note, '_processedAdded', null),
  date: get(note, '_processedDate', null),
});

export const getNoteDate = (details = {}, category) => get(
  details,
  category === 'service_provided' ? 'service_provided.date' : 'interaction.date',
  '',
);

export const getServiceProvidedData = (details = {}) => {
  const serviceProvided = get(details, 'service_provided', null);

  if (!serviceProvided) {
    return null;
  }

  const amount = get(serviceProvided, 'amount', '');
  const unit = get(serviceProvided, 'unit', '');

  return {
    amount,
    type: get(serviceProvided, 'type', ''),
    unit: unit === 'dollar' && amount > 1 ? `${unit}s` : unit,
  };
};

export const isNoteDeletable = (details = {}) => get(details, 'deletable', true);

export const shouldShowReason = (reason, details = {}) => Boolean(reason && get(details, 'context', null));

export const isCurrentEmployeeNoteOwner = (currentEmployeeId, note = {}) => (
  currentEmployeeId === get(note, 'employee.id')
);

export const shouldShowDeleteButton = ({
  currentEmployeeId,
  note,
  showDeleteNoteIcon,
}) => showDeleteNoteIcon && isCurrentEmployeeNoteOwner(currentEmployeeId, note);

export const canDeleteNote = ({
  currentEmployeeId,
  details,
  note,
  showDeleteNoteIcon,
}) => shouldShowDeleteButton({
  currentEmployeeId,
  note,
  showDeleteNoteIcon,
}) && isNoteDeletable(details);

export const shouldShowEditButton = ({
  category,
  currentEmployeeId,
  note,
  showEditNoteIcon,
}) => (
  showEditNoteIcon &&
  isCurrentEmployeeNoteOwner(currentEmployeeId, note) &&
  EDITABLE_NOTE_CATEGORIES.includes(category)
);
